import { handleActions } from 'redux-actions';
import actions from '../actions';

const { open, close } = actions.discountModal;

const discountModal = handleActions(
  {
    [open]: () => ({ active: true }),
    [close]: () => ({ active: false }),
  },
  {
    active: false,
  }
);

export default discountModal;



// WEBPACK FOOTER //
// ./src/reducers/discountModal.js